// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-pip';
import ConfirmationModal, {getDefaultState as getConfirmationModalDefaultState} from '../../shared/state/confirmation-modal';
import CreateClaimModalType, {getDefaultState as getCreateClaimModalTypeDefaultState} from '../../../shared/state/create-claim-modal';
import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import FormValidation, {getDefaultState as getDefaultFormValidationState} from './form-validation';
import KeyValuePairCollection, {getDefaultState as getDefaultKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import Parts, {getDefaultState as getPartsDefaultState} from '../../shared/state/parts';
import PipDetails, {getDefaultState as getPipDetailsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-details';
import PipProducts, {getDefaultState as getPipProductsDefaultState} from './pip-products';
import Product, {getDefaultState as getProductDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product';
import WarrantyStatusModal, {getDefaultState as getWarrantyStatusModal} from '../../../../src/claim/shared/state/warranty-status-modal';
import t from 'tcomb';

const PipClaim = t.struct({
    busyCounter: BusyCounter,
    claim: Claim,
    confirmationModal: ConfirmationModal,
    createClaimModal: CreateClaimModalType,
    customer: Customer,
    failureModes: KeyValuePairCollection,
    formValidation: FormValidation,
    isActionButtonDisabled: t.Boolean,
    isCopied: t.Boolean,
    isEditable: t.Boolean,
    isNonTracked: t.Boolean,
    isStickyHeaderVisible: t.Boolean,
    isValidClaim: t.Boolean,
    parts: Parts,
    pipDetails: PipDetails,
    pipProducts: PipProducts,
    product: Product,
    temporaryObjectKey: t.String,
    warrantyStatusModal: WarrantyStatusModal
}, 'PipClaim');

export const getDefaultState = () =>
    new PipClaim({
        busyCounter: getBusyCounterDefaultState(),
        claim: getClaimDefaultState(),
        confirmationModal: getConfirmationModalDefaultState(),
        createClaimModal: getCreateClaimModalTypeDefaultState(),
        customer: getCustomerDefaultState(),
        failureModes: getDefaultKeyValueCollection(),
        formValidation: getDefaultFormValidationState(),
        isActionButtonDisabled: false,
        isCopied: false,
        isEditable: true,
        isNonTracked: false,
        isStickyHeaderVisible: false,
        isValidClaim: false,
        parts: getPartsDefaultState(),
        pipDetails: getPipDetailsDefaultState(),
        pipProducts: getPipProductsDefaultState(),
        product: getProductDefaultState(),
        temporaryObjectKey: '',
        warrantyStatusModal: getWarrantyStatusModal()
    });

export default PipClaim;



// WEBPACK FOOTER //
// ./src/claim/pip/state/index.js